import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export const fieldsConditionsSet = _extends({}, fieldsIBaseModel, {
  andFilters: {
    type: 'Object',
    array: true
  },
  orFilters: {
    type: 'Object',
    array: true
  }
});